import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import { requestPersistentStorage } from '@/services/storagePersistence';
import '@/index.css';

// Protect queued PODs/signatures/logs from browser-initiated storage
// eviction (fire and forget; result lands in the device heartbeat).
void requestPersistentStorage();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
